import DetailComponent from '@components/detail';
import * as React from 'react';

export interface IDetailpageProps {}

export default function Detailpage(props: IDetailpageProps) {
  return <DetailComponent />;
}
